var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-content',{staticClass:"h-panel"},[_c('Tabs',{attrs:{"datas":_vm.datas},on:{"change":_vm.change},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }